/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const CMSUpdateIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="CMSUpdateIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.5752 1.79515C4.47691 1.2942 5.68875 1 7 1C8.31125 1 9.52309 1.2942 10.4248 1.79515C11.3096 2.2867 12 3.04561 12 4V7H11V5.82287C10.8227 5.96383 10.6289 6.09145 10.4248 6.20485C9.52309 6.7058 8.31125 7 7 7C5.68875 7 4.47691 6.7058 3.5752 6.20485C3.37109 6.09145 3.17733 5.96383 3 5.82287V7C3 7.42632 3.31694 7.91741 4.06084 8.33069C4.7878 8.73456 5.82597 9 7 9V10C5.68875 10 4.47691 9.7058 3.5752 9.20485C3.37109 9.09145 3.17733 8.96383 3 8.82287V10C3 10.4263 3.31694 10.9174 4.06084 11.3307C4.7878 11.7346 5.82597 12 7 12V13C5.68875 13 4.47691 12.7058 3.5752 12.2048C2.69042 11.7133 2 10.9544 2 10V4C2 3.04561 2.69042 2.2867 3.5752 1.79515ZM9.93916 2.66931C10.6831 3.08259 11 3.57368 11 4C11 4.42632 10.6831 4.91741 9.93916 5.33069C9.2122 5.73456 8.17403 6 7 6C5.82597 6 4.7878 5.73456 4.06084 5.33069C3.31694 4.91741 3 4.42632 3 4C3 3.57368 3.31694 3.08259 4.06084 2.66931C4.7878 2.26544 5.82597 2 7 2C8.17403 2 9.2122 2.26544 9.93916 2.66931Z"
                fill="currentColor"
              />
              <path
                d="M9 11C9 11.5523 9.22386 12.0523 9.58579 12.4142L8.87868 13.1213C8.33579 12.5784 8 11.8284 8 11C8 10.2316 8.28885 9.53076 8.76389 9H8V8H11V9C9.89543 9 9 9.89543 9 11Z"
                fill="currentColor"
              />
              <path
                d="M14 11C14 10.1716 13.6642 9.42157 13.1213 8.87868L12.4142 9.58579C12.7761 9.94771 13 10.4477 13 11C13 12.1046 12.1046 13 11 13V14H14V13H13.2361C13.7111 12.4692 14 11.7684 14 11Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

CMSUpdateIcon.tags = ['collection', 'coins', 'stack'];

CMSUpdateIcon.category = 'General Icons';

CMSUpdateIcon.iconSize = 16;
